<template>
  <SoDialog v-model="value" card-title="Open Complaint" :max-width="500">
    There is an open complaint on this account, please check the complaint
    ticket by clicking the button below.
    <div class="d-flex justify-end gap-1 mt-8">
      <SoButton
        data-testid="complaint-button"
        title="See complaint"
        type="success"
        large
        @click="($router.push({ name: complaintsRouteName }), (value = false))"
      />
      <SoButton title="close" large @click="value = false" />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { RouteNames } from "@/types/router"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        current: useCurrentAccountStore(),
        complaintsRouteName: RouteNames.CustomerComplaints,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
          this.current.seenOpenComplaints = true
        },
      },
    },
  })
</script>
